module.exports = { 
  NORMAL:               0, 
  NON_CONTRIBUTING:     1, 
  SAME_TRANSITION:      2, 
  DIFFERENT_TRANSITION: 3
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/martinez-polygon-clipping/src/edge_type.js
// module id = 323
// module chunks = 0